import {
  clearError,
  startLoading,
  stopLoading,
  saveErrorMsg,
} from "../../helpers/api/meta";
import { handleError } from "../error";
import { showSuccessSnackbar } from "../success";
import { getUserInfo, updateUserInfo ,resetPassword,changeToActive} from "../../helpers/api/api";
import { loadingAction } from "../loader";

export const GET_INFO_STARTED = "GET_INFO_STARTED";
export const GET_INFO_SUCCESS = "GET_INFO_SUCCESS";
export const GET_INFO_FAILURE = "GET_INFO_FAILURE";
export const GET_INFO_CLEAR = "GET_INFO_CLEAR";

export const UPDATE_INFO_STARTED = "UPDATE_INFO_STARTED";
export const UPDATE_INFO_SUCCESS = "UPDATE_INFO_SUCCESS";
export const UPDATE_INFO_FAILURE = "UPDATE_INFO_FAILURE";
export const UPDATE_INFO_CLEAR = "UPDATE_INFO_CLEAR";

export const getInfoStarted = () => ({ type: GET_INFO_STARTED });
export const getInfoSuccess = (data) => ({
  type: GET_INFO_SUCCESS,
  data: data,
});
export const getInfoFailure = (error) => ({ type: GET_INFO_FAILURE, error });
export const getInfoClear = () => ({ type: GET_INFO_CLEAR });

export const updateInfoStarted = () => ({ type: UPDATE_INFO_STARTED });
export const updateInfoSuccess = () => ({
  type: UPDATE_INFO_SUCCESS,
});
export const updateInfoFailure = (error) => ({
  type: UPDATE_INFO_FAILURE,
  error,
});
export const updateInfoClear = () => ({ type: UPDATE_INFO_CLEAR });

const messages = {
  id: "getUserInfo",
  getFailure: "Couldn't get user info.",
  updateFailure: "Couldn't update user.",
  updated: "User updated",
};

const initialState = {
  info: {},
  loading: false,
  error: {},
};

export const callGetUserInfoStart = (val) => (dispatch) => {
  dispatch(getInfoStarted());

  return getUserInfo(val)
    .then((success) => {
      dispatch(getInfoSuccess(success));
    })
    .catch((error) => {
      dispatch(getInfoFailure());
      handleError(dispatch, error, messages.id, messages.getFailure);
      throw error;
    });
};

export const callUpdateUserInfoStart = (userId, body) => (dispatch) => {
  dispatch(loadingAction(true));
  dispatch(updateInfoStarted());

  return updateUserInfo(userId, body)
    .then((success) => {
      dispatch(loadingAction(false));
      dispatch(updateInfoSuccess());
      dispatch(showSuccessSnackbar(messages.updated));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      dispatch(updateInfoFailure());
      handleError(dispatch, error, messages.id, messages.updateFailure);
      throw error;
    });
};

export const callUserInfoClear = () => (dispatch) => {
  dispatch(getInfoClear());
};

export default function userReducer(state = initialState, action) {
  switch (action.type) {
    case GET_INFO_STARTED: {
      return startLoading(clearError(state));
    }
    case GET_INFO_SUCCESS: {
      return { ...state, loading: false, info: action.data };
    }
    case GET_INFO_FAILURE: {
      return saveErrorMsg(stopLoading(state), action, messages.getFailure);
    }
    case GET_INFO_CLEAR: {
      return stopLoading(clearError(state));
    }
    case UPDATE_INFO_STARTED: {
      return startLoading(clearError(state));
    }
    case UPDATE_INFO_SUCCESS: {
      return { ...state, loading: false };
    }
    case UPDATE_INFO_FAILURE: {
      return saveErrorMsg(stopLoading(state), action, messages.updateFailure);
    }
    case UPDATE_INFO_CLEAR: {
      return stopLoading(clearError(state));
    }

    default:
      return state;
  }
}

export const callResetPasswordStart = (userId, body) => (dispatch) => {
  dispatch(loadingAction(true));
  dispatch(updateInfoStarted());

  return resetPassword(userId, body)
    .then((success) => {
      dispatch(loadingAction(false));
      dispatch(updateInfoSuccess());
      dispatch(showSuccessSnackbar(messages.updated));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      dispatch(updateInfoFailure());
      handleError(dispatch, error, messages.id, messages.updateFailure);
      throw error;
    });
};

export const callSetActiveStart = (userId, body) => (dispatch) => {
  dispatch(loadingAction(true));
  dispatch(updateInfoStarted());

  return changeToActive(userId, body)
    .then((success) => {
      dispatch(loadingAction(false));
      dispatch(updateInfoSuccess());
      dispatch(showSuccessSnackbar(messages.updated));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      dispatch(updateInfoFailure());
      handleError(dispatch, error, messages.id, messages.updateFailure);
      throw error;
    });
};